import { render, staticRenderFns } from "./PriceGuard.vue?vue&type=template&id=591772d4&scoped=true"
import script from "./PriceGuard.vue?vue&type=script&lang=js"
export * from "./PriceGuard.vue?vue&type=script&lang=js"
import style0 from "./PriceGuard.vue?vue&type=style&index=0&id=591772d4&lang=scss"
import style1 from "../css/utilities/priceGuard.css?vue&type=style&index=1&lang=css&external"
import style2 from "../css/utilities/scoped/priceGuard.css?vue&type=style&index=2&id=591772d4&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591772d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('591772d4')) {
      api.createRecord('591772d4', component.options)
    } else {
      api.reload('591772d4', component.options)
    }
    module.hot.accept("./PriceGuard.vue?vue&type=template&id=591772d4&scoped=true", function () {
      api.rerender('591772d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PriceGuard.vue"
export default component.exports